import { SERVICE_AREA } from "@/data/content";

export default function ServiceFootprint() {
  return <section aria-labelledby="service-footprint-heading" className="mb-16">
    <h2 id="service-footprint-heading" className="font-heading font-black text-3xl text-rc-blue">Our Florida Work Footprint</h2>
    <p className="mt-5 mb-8 text-lg leading-relaxed text-rc-brown">{SERVICE_AREA}</p>
    <img src="/assets/florida-service-footprint.svg?v=20261009" alt="Ranger's regional service coverage from near Ocala through greater Orlando and along eastern South Florida to the Florida Keys" className="w-full h-auto rounded-2xl" />
  </section>;
}
